export enum ActionPanelMode {
	None = 'none',
	Crm = 'crm',
	Slack = 'slack',
	Navigation = 'navigation'
}
